export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const footerLinks = [
    { label: "热门爆料", href: "#cards" },
    { label: "实时快讯", href: "#updates" },
    { label: "热门话题", href: "#topics" },
    { label: "吃瓜排行", href: "#ranking" },
    { label: "焦点专题", href: "#carousel" },
    { label: "关于我们", href: "#about" },
    { label: "联系我们", href: "#contact" },
    { label: "常见问题", href: "#faq" },
  ];

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="text-background-50 font-bold text-lg font-heading whitespace-nowrap">51吃瓜网站</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60 mb-4">
              51吃瓜网站是国内领先的娱乐八卦聚合平台，汇集全网最新51吃瓜网今日吃瓜资源，覆盖51吃瓜爆料、51吃瓜黑料、51吃瓜在线观看视频等内容，每日更新热门八卦与争议黑料，一站式吃瓜大全。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">更多链接</h4>
            <ul className="space-y-2.5">
              {footerLinks.slice(4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              合作伙伴信息待更新，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40 whitespace-nowrap">
            &copy; 2025 51吃瓜网站. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}